export const drawerWidth = 400;

/**
 * The RadikalWiki backend (a Rust service on Scaleway Serverless Containers).
 * It signs the links the Microsoft Office viewer fetches documents on, and is
 * shared with the new frontend.
 *
 * Overridable at build time so a dev build can point at a local backend.
 */
export const backendUrl =
	process.env.PUBLIC_BACKEND_URL ??
	"https://wikidioxusd0caa45e-wiki-backend.functions.fnc.fr-par.scw.cloud";
